import { Http } from "../utils/http.js";

export class DownloadService {
  retrieveDownloadDocument(docId) {
    var url = "/document/download";
    var postData = {
      miscFileParameter: {
        fileId: docId,
      },
    };

    return new Http().post(url, postData);
  }
}
